import { render } from "./ListeOrganePage.vue?vue&type=template&id=76773bcc&ts=true"
import script from "./ListeOrganePage.vue?vue&type=script&lang=ts"
export * from "./ListeOrganePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__